import React, {
  useState,
  useEffect
} from 'react';

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Button,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  StepContent,
  Typography,
  Tooltip,
  colors,
  List,
  ListItem
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import AdjustOutlinedIcon from '@material-ui/icons/AdjustOutlined';
import DeleteIcon from '@material-ui/icons/Delete';

import {
  StatusChip,
  DateTimeView,
  ProfileChip,
  UserComment,
  DocumentView
} from '../../general';

import {
  ThesisConsultation,
  Document,
} from '../../../types';
import localization from '../../../utils/localizations';
import lastStatus from '../../../utils/lastStatus';
import {
  BaseAPI,
} from '../../../data/BaseAPI';

const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  secondPanel: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  pageTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paddingTopBottom: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  consultationContainer: {
    marginTop: 20,
    marginBottom: 30,
  },
  marginRight: {
    marginRight: 10,
  },
  statusReason: {
    whiteSpace: 'pre-wrap',
  },
  reasonContainer: {
    paddingLeft: 10,
    borderLeft: "solid 2px",
    borderLeftColor: colors.blue[500],
  },
  marginVertical: {
    marginTop: 10,
    marginBottom: 10
  },
  marginTop: {
    marginTop: 10,
  },
}));



function ThesisConsultationHistory(props: {consultations: ThesisConsultation[]; onRemoved?: (id: string) => void}) {
  const classes = useStyles();
  const [removedList, setRemovedList] = useState([] as string[]);
  const consultations: ThesisConsultation[] = Object.assign([], props.consultations).reverse();

  const removeItem = async (consultation: ThesisConsultation) => {
    const newRemovedList = Array.from(removedList);
    newRemovedList.push(consultation.id);
    setRemovedList(newRemovedList);

    const api = new BaseAPI();
    try {
      const [result, response, error] = await api.delete(`s2/consultation/${consultation.id}/`);

      console.log('result', result)
      if (result.success) {
        if (props.onRemoved) props.onRemoved(consultation.id);
      }
      else {
        return result.errors;
      }
    } catch (error) {
      console.error(error);
      return [error.message];
    }
  }

  return (
    <Stepper orientation="vertical">
    {consultations.map((consultation, i) => {
      if (removedList.indexOf(consultation.id) > -1) return;
      
      let disableRemove = false;
      if (consultation.status === 'accepted') disableRemove = true;

      let lastUpdatedStatus = lastStatus(consultation.status_history);
      
      return (
        <Step key={`consultation-${consultation.id}`} active>
          <StepLabel StepIconComponent={AdjustOutlinedIcon}>
            <ProfileChip profile={consultation.advisor} size="small" className={classes.marginRight} />
            <StatusChip status={consultation.status ? consultation.status : 'updated'} size="small" className={classes.marginRight} />
            <DateTimeView
              value={consultation.created_at}
              fromNow
              chip
              size="small"
              className={classes.marginRight}
            />
            <Tooltip title={disableRemove ? localization.cannotRemoveAcceptedConsultationEntry : localization.remove}>
              <span>
                <IconButton
                  size="small"
                  onClick={() => {
                    if(window.confirm(localization.removeEntryPrompt)) removeItem(consultation);
                  }}
                  disabled={disableRemove}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </StepLabel>
          <StepContent>
            {consultation.content &&
            <div className={classes.reasonContainer}>
              <Typography className={classes.statusReason}>{consultation.content}</Typography>
            </div>
            }
            {lastUpdatedStatus?.comment &&
            <div>
              <Typography variant="subtitle2" className={classes.marginVertical}>{localization.comment}</Typography>
              <UserComment
                comment={lastUpdatedStatus.comment}
                inline
              />
            </div>
            }
            {consultation.documents.length > 0 &&
              <List subheader={<Typography variant="subtitle2">{localization.documents}</Typography>} className={classes.marginTop}>
                {consultation.documents.map((doc: Document, j: number) => {
                  return (
                    <ListItem key={`doc-dowload-${i}-${j}`}>
                      <DocumentView doc={doc} />
                    </ListItem>
                  );
                })}
              </List>
              }
          </StepContent>
        </Step>
      );
    })}
    </Stepper>
  );
}

export {ThesisConsultationHistory};
